export const socketKeys = {
    "JOIN_ADMIN": "chat-session-admin-join",
    "SEND_MESSAGE": "admin-message",
    "RECEIVE_MESSAGE": "on-message-receive",
    "END_CHAT": "chat-session-end-admin",
    "ON_CHAT_SESSION_END": "on-chat-session-end",
    "ON_CHAT_SESSION_AUTO_END": "on-chat-session-end-auto",
    "UPDATE_CHAT_LIST": "update-chat-session-list",
    "ORG_JOIN": "organization-session-admin-join",
    "TYPING": "admin-typing",
    "ON_VISITOR_TYPING": "on-visitor-typing",
    "ON_VISITOR_OFFLINE": "visitor-offline-status",

    "ON_INCOMING_CALL": "incoming-call",
    "ADMIN_ANSWER_CALL": "admin-call-answer",
    "REJECT_CALL": "admin-call-reject",
    "ICE_CANDIDATE": "ice-candidate",
    "ON_VISITOR_CALL_OFFER": "on-visitor-call-offer",
    "ANSWERING_CALL": "call-answered",
    "START_WEBRTC": "start-webrtc",
    "CALL_HANG": "call-hang"
}